<ion-list lines="none" class="horizontal-days-list">
  @for (day of days; track day.date; let i = $index) {
    <ion-item
      class="day-item ion-no-padding ion-no-margin"
      [ngClass]="{'selected': selectedDayIndex === i}"
      detail="false"
      button
      (click)="selectDay(i)">
      <ion-label class="ion-text-center ion-no-margin">
        <aaa-text weight="bold">{{ day.date | date:'d' }}</aaa-text>
        <aaa-text size="caption" color="medium">{{ getDayLabel(day.date) }}</aaa-text>
      </ion-label>
    </ion-item>
  }
</ion-list>